/**
 * Sistema de temas para os diferentes módulos
 * Cada módulo tem seu próprio esquema de cores
 */

export const themes = {
    ariba: {
        name: 'Ariba',
        primary: '#e67e22',
        primaryLight: '#f39c12',
        primaryDark: '#d35400',
        gradient: 'linear-gradient(135deg, #e67e22 0%, #d35400 100%)',
        buttonShadow: 'rgba(230, 126, 34, 0.3)',
        buttonShadowHover: 'rgba(230, 126, 34, 0.4)',
        backButtonBg: 'rgba(230, 126, 34, 0.1)',
        backButtonBgHover: 'rgba(230, 126, 34, 0.2)',
    },
    viceri: {
        name: 'Viceri',
        primary: '#667eea',
        primaryLight: '#764ba2',
        primaryDark: '#5568d3',
        gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        buttonShadow: 'rgba(102, 126, 234, 0.3)',
        buttonShadowHover: 'rgba(102, 126, 234, 0.4)',
        backButtonBg: 'rgba(102, 126, 234, 0.1)',
        backButtonBgHover: 'rgba(102, 126, 234, 0.2)',
    },
    concur: {
        name: 'Concur',
        primary: '#8e44ad',
        primaryLight: '#9b59b6',
        primaryDark: '#7d3c98',
        gradient: 'linear-gradient(135deg, #8e44ad 0%, #9b59b6 100%)',
        buttonShadow: 'rgba(142, 68, 173, 0.3)',
        buttonShadowHover: 'rgba(142, 68, 173, 0.4)',
        backButtonBg: 'rgba(142, 68, 173, 0.1)',
        backButtonBgHover: 'rgba(142, 68, 173, 0.2)',
    },
    comerzzia: {
        name: 'Comerzzia',
        primary: '#667eea',
        primaryLight: '#764ba2',
        primaryDark: '#5568d3',
        gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        buttonShadow: 'rgba(102, 126, 234, 0.3)',
        buttonShadowHover: 'rgba(102, 126, 234, 0.4)',
        backButtonBg: 'rgba(102, 126, 234, 0.1)',
        backButtonBgHover: 'rgba(102, 126, 234, 0.2)',
    },
    ifs: {
        name: 'IFS',
        primary: '#ff6b35',
        primaryLight: '#ff8c61',
        primaryDark: '#e85a2a',
        gradient: 'linear-gradient(135deg, #ff6b35 0%, #e85a2a 100%)',
        buttonShadow: 'rgba(255, 107, 53, 0.3)',
        buttonShadowHover: 'rgba(255, 107, 53, 0.4)',
        backButtonBg: 'rgba(255, 107, 53, 0.1)',
        backButtonBgHover: 'rgba(255, 107, 53, 0.2)',
    },
    senior: {
        name: 'Senior WMS',
        primary: '#84cc16',
        primaryLight: '#a3e635',
        primaryDark: '#65a30d',
        gradient: 'linear-gradient(135deg, #84cc16 0%, #65a30d 100%)',
        buttonShadow: 'rgba(132, 204, 22, 0.3)',
        buttonShadowHover: 'rgba(132, 204, 22, 0.4)',
        backButtonBg: 'rgba(132, 204, 22, 0.1)',
        backButtonBgHover: 'rgba(132, 204, 22, 0.2)',
    },
    default: {
        name: 'Default',
        primary: '#667eea',
        primaryLight: '#764ba2',
        primaryDark: '#5568d3',
        gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        buttonShadow: 'rgba(102, 126, 234, 0.3)',
        buttonShadowHover: 'rgba(102, 126, 234, 0.4)',
        backButtonBg: 'rgba(102, 126, 234, 0.1)',
        backButtonBgHover: 'rgba(102, 126, 234, 0.2)',
    },
};

/**
 * Cores compartilhadas entre todos os temas
 */
export const sharedColors = {
    // Status colors
    success: '#27ae60',
    successLight: 'rgba(39, 174, 96, 0.1)',
    error: '#e74c3c',
    errorLight: 'rgba(231, 76, 60, 0.1)',
    warning: '#f39c12',
    warningLight: 'rgba(243, 156, 18, 0.1)',
    info: '#3498db',
    infoLight: 'rgba(52, 152, 219, 0.1)',

    // Connection colors
    connected: '#3498db',
    connectedLight: 'rgba(52, 152, 219, 0.1)',
    disconnected: '#95a5a6',
    disconnectedLight: 'rgba(149, 165, 166, 0.1)',

    // Neutral colors
    white: '#ffffff',
    black: '#000000',
    gray100: '#f9fafb',
    gray200: '#f5f5f5',
    gray300: '#e8e8e8',
    gray400: '#d0d0d0',
    gray500: '#6b7280',
    gray600: '#4c5968',
    gray700: '#2c3e50',
    gray800: '#1f2933',

    // Text colors
    textPrimary: '#2c3e50',
    textSecondary: '#7f8c8d',
    textLight: '#64748b',

    // Border colors
    borderLight: '#eef2f7',
    borderMedium: '#e5e7eb',
    borderDark: '#d0d0d0',

    // Background colors
    bgGradient: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
    bgCard: '#ffffff',
    bgHover: '#f9fbff',
};

/**
 * Helper para obter tema por módulo
 * @param {string} module - Nome do módulo (ariba, viceri, concur, etc)
 * @returns {object} Objeto com configurações do tema
 */
export const getTheme = (module) => {
    return themes[module] || themes.default;
};

/**
 * Hook customizado para usar tema (para uso futuro com Context API)
 */
export const useTheme = (module) => {
    return {
        ...getTheme(module),
        shared: sharedColors,
    };
};
